<template>
    <div id="default_parameters">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
                <li class="breadcrumb-item active" aria-current="page">Default Parameters</li>
            </ol>
        </nav>
        <big-title class="w-full">
            Default Parameters
            <p class="text-subtitle mt-4">
                Apartado para administración de las variables que se utilizan en el sistema.
            </p>
        </big-title>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <vx-card>
                        <vs-table search :data="params" max-items="20" pagination noDataText="Sin información disponible" stripe>
                            <template slot="header">
                                <h3>Lista de variables default_parameters</h3>
                            </template>
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].id">
                                        {{ data[indextr].id }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].field_name">
                                        {{ data[indextr].field_name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].type">
                                        {{ data[indextr].type }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].value">
                                        <vs-input v-if="isEdit && data[indextr].id == param.id" name="value" color="success" v-model="value" required/>
                                        <template v-else>{{ data[indextr].value }}</template>
                                    </vs-td>

                                    <vs-td :data="data[indextr].modify_by">
                                        {{ data[indextr].modify_by }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].updated_at">
                                        {{ dateTime12Format(data[indextr].updated_at) }}
                                    </vs-td>
                                    <vs-td>
                                        <feather-icon @click="prepareEdit(tr)" icon="EditIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="ml-6" />
                                        <feather-icon  v-if="isEdit && data[indextr].id == param.id" @click="confirmSave()" icon="SaveIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" />
                                        <span  v-if="isEdit && data[indextr].id == param.id" @click="cancelEdit()" class="ml-6 feather-icon select-none relative"><md-icon style>close</md-icon></span>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
const columns = [
    { title: "ID", key:"id", sortable: true }
    , { title: "NOMBRE", key:"field_name", sortable: true }
    , { title: "TIPO", key:"type", sortable: true }
    , { title: "VALOR", key:"value", sortable: true }
    , { title: "UID", key:"uid", sortable: true }
    , { title: "FECHA DE MODIFICACIÓN", key:"updated_at", sortable: true }
    , { title: "", key:"actions", sortable: true }
];
export default {
    mixins: [dateHelper],
    data() {
        return {
            params: []
            , columns: columns
            , param : {
                created_at: ""
                , field_name: ""
                , id: 0
                , modify_by: 0
                , type: ""
                , updated_at: ""
                , value: ""
            }
            , isEdit: false
            , popUpConfirmartion: false
            , value: ""

        }
    },
    created() {
        this.getDefaultParameters();
    },
    methods: {
        async getDefaultParameters(){
            this.showLoading(true);
            try{
                let response = await axios.get('/api/parameters_default');
                this.params = response.data;
            } catch(err) {
                console.log("Error");
            }
            this.showLoading(false);
        },
        prepareEdit(param){
            this.param = param;
            this.isEdit = true;
        },
        cancelEdit(){
            this.param =  {
                created_at: ""
                , field_name: ""
                , id: 0
                , modify_by: 0
                , type: ""
                , updated_at: ""
                , value: ""
            };
            this.isEdit = false;
            this.value = "";
        },
        confirmSave(){
            if(this.value != ""){
                let text = `Confirme que desea editar el registro con valor <<${this.value}>> para la variable <<${this.param.field_name}>>. `;
                text += "Esta operación no podrá deshacerse y existe riesgo de fallos en el sistema si la vairable es utlizada en uno o más procesos.";
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "Actualizar default_parameters",
                    text: text,
                    acceptText: "Actualizar",
                    cancelText: "Cancelar",
                    accept:this.saveData
                });
            } else {
                this.missingFieldsNotif();
            }
        },
        async saveData() {
            this.showLoading(true);
            try{
                this.param.value = this.value;
                await axios.put('/api/updateDefaultParameters', this.param);
                this.getDefaultParameters();
                this.cancelEdit();
                this.showLoading(false);
                this.saveSuccessNotif()
            } catch (err) {
                this.showLoading(false);
                this.failedOperationNotif()
            }
        }
    }
}
</script>

<style>
    .md-icon {
        margin-top: -10px;
        margin-left: -4px;
        font-weight: 500;
        cursor: pointer;
    }

    .md-icon:hover {
        color:#f44336 !important;
    }
</style>